// Branding officiel Gino Body & Soul / CYCLIQ.
// Logo noir : à utiliser sur fonds clairs (header, footer, cartes blanches).
// Logo blanc : à utiliser sur fonds foncés (sections bleu marine #235277).
export const LOGO_BLACK =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cycliq-diagnostic/artifacts/x7qy6yjo_LOGO%20GINO%20BODY%20NOIR.png";

export const LOGO_WHITE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cycliq-diagnostic/artifacts/xpzc53zq_LOGO%20GINO%20BODY%20BLANC.png";

// Signature officielle placée sous le logo (identité CYCLIQ validée).
export const TAGLINE = "Comprenez vos cycles. Vivez enfin à votre rythme.";
